import React from "react";

const FireIconEmpty = () => {
  return (
    <svg width={10} height={13} viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.97894 3.97955C1.91836 4.63827 1.87585 5.80401 2.25738 6.30021C2.25738 6.30021 2.07778 5.01962 3.68784 3.41293C4.33612 2.76614 4.48597 1.88641 4.2596 1.22662C4.13101 0.852842 3.89614 0.544071 3.6921 0.328473C3.57307 0.201714 3.66446 -0.00738314 3.83769 0.000200708C4.88556 0.0478706 6.58384 0.344724 7.30545 2.19085C7.62215 3.00124 7.64553 3.83871 7.49462 4.69027C7.39897 5.23414 7.05889 6.44322 7.8347 6.59165C8.38839 6.69782 8.65621 6.24929 8.7763 5.92644C8.82625 5.79209 8.99947 5.75851 9.093 5.86577C10.0282 6.95026 10.1079 8.22759 9.9145 9.32725C9.54042 11.4529 7.42873 13 5.33086 13C2.71011 13 0.623932 11.4713 0.0829919 8.70429C-0.134872 7.5873 -0.0243457 5.37715 1.66543 3.81704C1.79083 3.70004 1.99594 3.80404 1.97894 3.97955Z"
        fill="#bfbfbf"
      />
    </svg>
  );
};

export default FireIconEmpty;
